import { render, staticRenderFns } from "./card-email.vue?vue&type=template&id=98cf3954"
import script from "./card-email.vue?vue&type=script&lang=js"
export * from "./card-email.vue?vue&type=script&lang=js"
import style0 from "./card-email.vue?vue&type=style&index=0&id=98cf3954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports